import { HttpParams } from '@angular/common/http'
import { Component, DestroyRef, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { RouterLink } from '@angular/router'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, Bid, VpUser } from '../../shared'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

interface BidValidationGroup {
    categoryKey: string
    title: string
    description: string
    bids: Bid[]
}

@Component({
    templateUrl: './history-validation.component.html',
    standalone: true,
    imports: [RouterLink, WjGridModule, WjGridFilterModule, AutoSizeDirective],
})
export class HistoryValidationComponent extends BaseComponent {
    groups: BidValidationGroup[] = []
    jobTypeMap!: DataMap
    countiesMap!: DataMap
    ownersMap!: DataMap
    allUserMap!: DataMap

    private destroyRef = inject(DestroyRef)

    constructor() {
        super()
        this.refresh()
    }

    refresh() {
        this.services.data
            .load(
                true,
                true,
                this.services.data.get('/api/Bid/GetValidationIssues'),
                this.services.data.jobTypes.queryAll(),
                this.services.data.counties.queryAll(),
                this.services.data.get('/api/VpOwner/GetOwners'),
                this.services.data.get('api/VpUser/GetVistaUsers', new HttpParams().set('activeOnly', false)),
            )
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.groups = result[0] as BidValidationGroup[]
                    this.jobTypeMap = new DataMap(result[1], 'id', 'fullName')
                    this.countiesMap = new DataMap(result[2], 'id', 'combinedName')
                    this.ownersMap = new DataMap(result[3], 'id', 'name')
                    this.allUserMap = new DataMap(result[4] as VpUser[], 'id', 'name')
                },
            })
    }
}
